// /src/utils/scrollToTop.js

const scrollToTop = () => {
    // Scroll the window
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });

    // Also scroll the .routing-guide-content container, if present
    const container = document.querySelector('.routing-guide-content');
    if (container && container.scrollHeight > container.clientHeight) {
        container.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }
};

export default scrollToTop;
